import { DateRange } from 'components/filter/input/DateRangePicker/types';
import { IntlShape } from 'react-intl';

export const formatDateRangeLabel = (range: DateRange | undefined, intl: IntlShape) => {
  if (!range) return '';
  if (range.presetLabel) {
    return intl.formatMessage({ id: range.presetLabel });
  }
  return range.from && range.to ? intl.formatDateTimeRange(range.from, range.to) : '';
};
